<template>
    <div class="header-container-desktop" :class="{'is-black': isBlack && scrolling == 0, 'is-fixed': isFixed, 'is-open': megaMenuOpen , 'is-scroll': isFixed && scrolling > 0, 'is-mobile': isMobileMode }" @mouseleave="showLogin(false)" >
        <div class="header" :class="{ scroll: scrolling }">
            <div class="logo">
                <a href="/"
                    ><svg class="icon illust icon-renault-new">
                        <title>Logo renault</title>
                        <use xlink:href="#icon-renault-new"></use>
                    </svg>
                </a>
                <div class="elements">
                    <span class="text"
                        >{{ $t("header.tooltip.title") }}
                        <i class="ox-menu-arrow"></i>
                    </span>
                    <ul class="list">
                        <li
                            class=""
                            v-for="(original, index) in originals"
                            :key="index"
                        >
                            <a :href="original.url" class="header-link">{{
                                original.text
                            }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="links">
                <template v-for="item in list">
                    <a
                        v-if="item.isLink"
                        :href="item.url"
                        class="href -document to-megamenu"
                        :target="item.target"
                        :class="{'active': item.url == pathname}"
                        @mouseover="
                            MegaMenu(item.openMega);
                        "
                        >{{ item.text }}</a
                    >
                    <div
                        v-else
                        class="href -document to-megamenu"
                        @mouseover="
                            MegaMenu(item.openMega);
                        "
                    >
                        {{ item.text }}
                    </div>
                </template>
            </div>

            <div class="lang"><languages-selector :color="{'isblack': isBlack && scrolling == 0, 'isfixed': isFixed, 'isopen': megaMenuOpen , 'isscroll': isFixed && scrolling > 0}" /></div>

            <div class="button-and-svg">
                <!-- <div  @click="showLogin(true)" class="login-container -pointer"  @mouseover="showLogin(true)"  >
                    <svg class="icon icon-login">
                        <use xlink:href="#icon-login"></use>
                    </svg>
                    <svg class="icon-connected" v-if="isConnected" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="4" cy="4" r="4" fill="#424242"/>
                    </svg>
                </div> -->

                <svg class="icon icon-burger" @click="showMenu">
                    <use xlink:href="#icon-burger"></use>
                </svg>
                

                <!-- <div class="absolute login" :class="{'-not-connected': !isConnected}" v-if="showLoginPopin" @mouseleave="showLogin(false)" >
                    <svg width="22" height="22" viewBox="0 0 22 22"  xmlns="http://www.w3.org/2000/svg">
                        <rect y="10.6074" width="15" height="15" transform="rotate(-45 0 10.6074)" />
                    </svg>
                    <ButtonConnexion column v-if="!isConnected"/>
                    <div v-else class="d-flex column gap-16 connected">
                        <a class="d-flex gap-16" href="/profile" >
                            <svg class="icon icon-login">
                                <use xlink:href="#icon-login"></use>
                            </svg>
                            {{$t('profile.title')}}
                        </a>
                        <a href="/logout" class="d-flex align-center gap-8" > 
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4996 1.6665H9.49956V10.4165H10.4996V1.6665Z" fill="black"/>
                                <path d="M2.07182 11.5379C2.63076 15.4861 6.01197 18.4199 9.99957 18.4165C13.9872 18.4199 17.3684 15.4861 17.9273 11.5379C18.4862 7.58963 16.0522 3.83263 12.2204 2.729L11.9454 3.6915C15.2943 4.66063 17.4197 7.94643 16.9303 11.3983C16.4408 14.8501 13.4859 17.4156 9.99957 17.4156C6.51321 17.4156 3.55829 14.8501 3.06888 11.3983C2.57947 7.94643 4.70478 4.66063 8.05373 3.6915L7.77873 2.729C3.9469 3.83263 1.51289 7.58963 2.07182 11.5379Z" fill="black"/>
                            </svg>
                            {{$t('profile.logout-popin')}}
                        </a>
                    </div>
                </div> -->
            </div>
            
        </div>

        <!-- Mega Menu Services -->
        <div
            class="megamenu-wrapper dus-container pt-40 pb-80"
            :class="megaMenuOpen ? 'active' : ''"
            @mouseleave="MegaMenu(false)"
        >
            <div class="grid">
                <div v-for="(service, index) in services">
                    <div class="subtitle mb-20">
                        {{ service.text }}
                    </div>
                    <div v-for="item in service.list" class="menu-list">
                        <a :href="item.url" :target="item.target">
                            {{ item.text }}
                        </a>
                    </div>
                </div>
                <a href="https://theoriginals-services.renault.com/evenement/45" class="card-image" target="_blank">
                    <img src="../../../images/retromobile.webp"  />
                    <p >{{$t('header.card_description')}} </p>
                   <span> {{$t('header.seemore')}}  </span>
                </a>
            </div>
        </div>

        <HeaderMobile 
            v-if="isMobileMode"
            :show="show" 
            :originals="originals"
            :list="list"
            :services="services"
            @close="closeMenu"
            :color="{'isblack': isBlack && scrolling == 0, 'isfixed': isFixed, 'isopen': megaMenuOpen, 'isscroll': isFixed && scrolling > 0}"
        />
    </div>
</template>

<script>
import LanguagesSelector from "./LanguagesSelector.vue";
import mixinHeader from "./mixinHeader";
import HeaderMobile from "./HeaderMobile.vue";
import ButtonConnexion from "../Auth/ButtonConnexion.vue";
export default {
    components: {
        LanguagesSelector,
        HeaderMobile,
        ButtonConnexion
    },
    mixins: [mixinHeader],
    props: {
        isBlack: {
            type: Boolean,
            default: false
        },
        isFixed: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            show: false,
            megaMenuOpen: false,
            isMobile: false,
            scrolling: false,
            showLoginPopin: false,
            pathname: location.pathname,
            isConnected: window.data.user_session
        };
    },
    computed: {
        currentLang() {
            return this.$store.state.languages.current;
        },

        isMobileMode() {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(
                navigator.userAgent
            );
            if (isMobile) return true;
            return false;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const menu = document.querySelector(".header");
            if (!menu) {
                return;
            }
            if (window.scrollY > 0) {
                this.scrolling = true;
                let headerHeight = menu.offsetHeight;
                document.documentElement.style.setProperty(
                    "--headerHeight",
                    `${headerHeight}px`
                );
            } else {
                this.scrolling = false;
                document.documentElement.style.setProperty(
                    "--headerHeight",
                    `117px`
                );
            }
        },
        showMenu() {
            this.show = true;
            this.showLoginPopin = false
        },
        MegaMenu(value) {
             this.megaMenuOpen = value
             this.showLoginPopin = false
        },
        toggleElement(el) {
            el = !el;
        },
        closeMenu() {
            this.show = false
        },
        showLogin(value) {
            this.showLoginPopin = value
            this.showMenu = false
            this.megaMenuOpen = false
           
        },
    },
};
</script>
